export default __webpack_public_path__ + "static/media/pic4.2a9f0124.jpg";